var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicMdHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.75,
    height: 21,
    viewBox: "0 0 22.75 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-home",
    "data-name": "Icon ionic-md-home",
    d: "M12.125,25.5v-7h5.25v7h5.337V15h3.413L14.75,4.5,3.375,15H6.787V25.5Z",
    transform: "translate(-3.375 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicMdHome);
export default __webpack_public_path__ + "static/media/ionic-md-home.4310203073638215d76874050593fd77.svg";
export { ForwardRef as ReactComponent };